import { toast } from "react-toastify";
import fetcher from "../../../lib/fetcher";
import useSWRMutation from "swr/mutation";
import { IUserOtpRequest } from "../../interfaces";

const useAuthUserSingUp = () => {
  async function authUserNumberPhone(
    url: string,
    {
      arg,
    }: {
      arg: {
        phone: string;
        marketingConsent?: boolean;
        personalDataConsent: boolean;
        privacyPolicyConsent: boolean;
      };
    }
  ) {
    try {
      const data = await fetcher.post<IUserOtpRequest>(url, {
        ...arg,
        marketingConsent:
          arg.marketingConsent === false ? undefined : arg.marketingConsent,
      });
      return data.result?.data;
    } catch (error: any) {
      toast.error(`Что-то не так. Проверьте номер. Причина: ${error}`);
      throw new Error(error);
    }
  }

  const { data, error, isMutating, trigger } = useSWRMutation(
    "/auth/sign-up-stricted",
    authUserNumberPhone
  );

  return { data: data, error, isMutating, trigger };
};
export default useAuthUserSingUp;
